import { z } from 'zod';
export const HydrationStepInputSchema = z.object({
    orgIds: z.array(z.string()),
    executionArn: z.string().optional(),
});
export const HydrationOrgStepInputSchema = z.object({
    orgId: z.string(),
    executionArn: z.string().optional(),
});
